import React from 'react'
import styled from 'styled-components'

import useIndexPageData from '../../../cmsHooks/useIndexPageData'
import CMS from '@talus-analytics/library.airtable-cms'

import { Center } from '../../layout'
import Demo from './demo/Demo'
import device from '../../../utilities/device'

import { FullWidthSection, ContentContainer } from '../../layout'

const Header = styled.h2`
  text-align: center;
`
const Description = styled.div`
  line-height: 30px;
  text-align: center;
  margin-top: 20px;
  font-size: 22px;
  margin-bottom: 60px;
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`
const DemoSection = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <FullWidthSection lightGray>
      <ContentContainer>
        <Center cross>
          <Header>
            <CMS.Text name="Demo headline" data={data} />
          </Header>
          <Description>
            <CMS.RichText name="Demo description" data={data} />
          </Description>
          <Grid>
            <Demo type={'Light'} />
            <Demo type={'Dark'} />
          </Grid>
        </Center>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default DemoSection
